// ============================================================
// MANIC MEETER — English
// ============================================================

import type { LocaleContent } from "../contract";
import { UI } from "./ui";
import { COLLEAGUE_ROLES, DEPARTMENTS, MEETING_SCENES, MEETING_TYPES, PLAYER_ROLES } from "./world";
import { CATCH_PHRASES } from "./colleagues";
import { FOREIGN_COLLEAGUE } from "./foreign";
import { FIRST_NAMES } from "../names";
import {
  ACHIEVEMENTS, BINGO_GOALS, ENDINGS, PERKS, PERMANENT_UNLOCKS, POSITIVE_EVENTS, POWERUPS,
  STAT_UPGRADES, VENDORS, WEEKEND_EVENTS,
} from "./catalog";
import {
  addressPhrases, BOSS_QUESTIONS, BRAINSTORMING_WORDS, BUZZWORD_BINGO_CHALLENGES,
  CODE_REVIEW_CHALLENGES, DIRECTION_CHANGE_QUOTES, EMAIL_SORTIEREN_CHALLENGES,
  KALENDER_TETRIS_CHALLENGES, KI_HALLUZINATION_CHALLENGES, MEETING_QUESTIONS,
  PROCRASTINATION_ACTIVITIES, RANDOM_ENCOUNTERS, RANDOM_MEETING_FLAVOR, SIMON_SAYS_CHALLENGES,
} from "./events";

export const en: LocaleContent = {
  locale: "en",
  htmlLang: "en",
  endonym: "English",
  flag: "🇬🇧",

  ui: UI,

  departments: DEPARTMENTS,
  colleagueRoles: COLLEAGUE_ROLES,
  playerRoles: PLAYER_ROLES,
  meetingTypes: MEETING_TYPES,
  meetingScenes: MEETING_SCENES,

  firstNames: FIRST_NAMES,
  catchPhrases: CATCH_PHRASES,
  foreignColleague: FOREIGN_COLLEAGUE,

  statUpgrades: STAT_UPGRADES,
  powerupTexts: POWERUPS,
  perks: PERKS,
  achievements: ACHIEVEMENTS,
  endings: ENDINGS,
  permanentUnlocks: PERMANENT_UNLOCKS,
  vendors: VENDORS,
  bingoGoals: BINGO_GOALS,
  weekendEvents: WEEKEND_EVENTS,
  positiveEvents: POSITIVE_EVENTS,

  events: {
    procrastination: PROCRASTINATION_ACTIVITIES,
    meetingQuestions: MEETING_QUESTIONS,
    bossQuestions: BOSS_QUESTIONS,
    brainstorming: BRAINSTORMING_WORDS,
    simonSays: SIMON_SAYS_CHALLENGES,
    buzzwordBingo: BUZZWORD_BINGO_CHALLENGES,
    emailSortieren: EMAIL_SORTIEREN_CHALLENGES,
    kalenderTetris: KALENDER_TETRIS_CHALLENGES,
    codeReview: CODE_REVIEW_CHALLENGES,
    kiHalluzination: KI_HALLUZINATION_CHALLENGES,
    meetingFlavor: RANDOM_MEETING_FLAVOR,
    encounters: RANDOM_ENCOUNTERS,
    directionChange: DIRECTION_CHANGE_QUOTES,
    addressPhrases,
  },
};
